import one from '../Images/nit.png'
import two from '../Images/sjain.jpg'
import three from '../Images/ab.jpeg'
import four from '../Images/inside.jpg'
import spons1 from '../Images/newspons2.jpeg'
import spons2 from '../Images/newspons4.jpeg'
import spons3 from '../Images/newspons5.jpeg'
import spons4 from '../Images/newspons6.jpeg'
import spons5 from '../Images/newspons7.jpeg'
import spons6 from '../Images/newspons8.png'
import spons7 from '../Images/newspons9.jpeg'

const Spons = [
   {
    url: one
   },
   {
    url:two
   },{
    url:three
   },{
    url:four
   },{
    url:spons1
   },{
    url:spons2
   },{
    url:spons3
   },{
    url:spons4
   },{
    url:spons5
   },{
    url:spons6
   },{
    url:spons7
   }

]

export default Spons